import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bcd82fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100vw","height":"100vh","color":"red","display":"flex","align-items":"center","justify-content":"center"} }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " 请使用微信扫一扫，扫描此二维码！ "))
}